(() => {
    "use strict";
    const t = async (t, e) => {

        if(t && typeof t.item_count!="undefined" ){
            document.getElementById("product-items").innerHTML=t.item_count;
        }
            console.log("update-cart",t),
                t && (t.description && 200 !== t.status ? window.toast.error({ message: t.description, icon: !1 }) : e || window.dispatchEvent(new Event("dynamic-cart-open"))),
                ((t, e, i = {}) => {
                    const n = new CustomEvent(e, { detail: i });
                    t.dispatchEvent(n);

                })(window, "ajax-cart", { cartSections: t.sections });


        },
        e = async (e, i) => {
            console.log("change-cart"), window.dispatchEvent(new Event("dynamic-cart-loading"));
            const n = await fetch("/cart/change.js", { method: "POST", body: JSON.stringify({ id: e, quantity: i, sections: ["cart-main", "dynamic-cart"] }), headers: { "Content-Type": "application/json" } }),
                a = await n.json();
            t(a, !0);
        };
    class i extends HTMLElement {
        constructor() {
            super(),

                // (this.agreeCheckbox) =  document?.getElementById("agree"),
                (this.closeButton = this.querySelector("[data-close-dynamic-cart]")),
                (this.wrapper = this.querySelector("[data-dynamic-cart-wrapper]")),
                (this.itemsList = this.querySelector("[data-items-list]")),
                (this.cartFooter = this.querySelector("[data-cart-footer]")),
                (this.form = this.querySelector("form")),
                this.closeButton.addEventListener("click", this.closeCart.bind(this)),
                window.addEventListener("dynamic-cart-loading", this.loading.bind(this)),
                window.addEventListener("dynamic-cart-open", this.openCart.bind(this)),
                window.addEventListener("ajax-cart", this.updateCart.bind(this)),
                this.addEventListener("click", this.closeCart.bind(this)),
                this.wrapper.addEventListener("click", (t) => {
                    t.stopPropagation();
                }),
                this.initItemsInteractions();
        }
        initItemsInteractions() {
            (this.quantityInputs = Array.from(this.querySelectorAll("[data-input-item-key]"))),
                (this.removeButtons = Array.from(this.querySelectorAll("[data-remove-item]"))),
                (this.quantityChangeFunction = this.quantityChange.bind(this)),
                this.quantityInputs.forEach((t) => {
                    t.addEventListener("change", this.quantityChangeFunction);
                }),
                this.removeButtons.forEach((t) => {
                    t.addEventListener("click", this.removeItem);
                });


                // console.log("agreee checkbox" ,  this,agreeCheckbox)
                // this.agreeCheckbox.addEventListener("change",(e)=>{
                //     console.log("wwdq" ,  e)
                // })
        }
        closeCart(t) {
            t.preventDefault(), this.removeAttribute("opened"), this.setAttribute("closed", "");
        }
        openCart() {
            this.setAttribute("opened", ""), this.removeAttribute("closed");
        }
        loading() {
            this.form.classList.add("loading-state", "loading");
        }
        quantityChange(t) {
            const i = t.currentTarget;
            e(i.dataset.inputItemKey, i.value);
        }
        removeItem(t) {
            t.preventDefault();
            const i = t.currentTarget;
            e(i.dataset.removeItem, 0);
        }

        updateCart(t) {
            this.form.classList.remove("loading-state", "loading");
        
            // Log the entire cartSections object for debugging
            console.log('Cart Sections:', t.detail.cartSections);
        
            const e = t.detail.cartSections ? t.detail.cartSections["dynamic-cart"] : null;
        
            if (e) {
                const i = document.createElement("div");
                i.innerHTML = e.replaceAll("dynamic-cart>", "div>");
                const n = i.querySelector("[data-items-list]").innerHTML;
                const a = i.querySelector("[data-cart-footer]").innerHTML;
                this.itemsList.innerHTML = n;
                this.cartFooter.innerHTML = a;
                this.initItemsInteractions();
            } else {
                console.log('The "dynamic-cart" section is not available.');
            }
        }
    }
    customElements.define("dynamic-cart", i);
})();
